export const isOnTaskView = routeName => {
  const TASK_ROUTES = ['wgpt_tasks_editor'];
  return TASK_ROUTES.includes(routeName);
};

export const isOnCampaignView = routeName => {
  const CAMPAIGN_ROUTES = ['wgpt_campaigns_editor'];
  return CAMPAIGN_ROUTES.includes(routeName);
};

export const isOnBotView = routeName => {
  const BOT_ROUTES = ['wgpt_bots_edit', 'wgpt_bots_edit_tool'];
  return BOT_ROUTES.includes(routeName);
};

export const isOnIntegrationHooks = routeName => {
  const INTEGRATION_ROUTES = [
    'settings_integrations_salla',
    'settings_integrations_zid',
  ];
  return INTEGRATION_ROUTES.includes(routeName);
};
